'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../external/classnames/index.js');

var PropTypes = require('prop-types');

var AccordionItem = require('./AccordionItem/AccordionItem.js');

var slugify = require('../../utilities/slugify.js');

require('../../utilities/nav.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Accordion = function Accordion(_ref) {
  var accordionItems = _ref.accordionItems,
      className = _ref.className,
      heading = _ref.heading;
  var accordionClasses = index['default']('lanl-accordion', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: accordionClasses,
    "data-testid": "lanl-accordion"
  }, heading !== '' && /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "accordion-title"
  }, heading), accordionItems.map(function (_ref2) {
    var title = _ref2.title,
        content = _ref2.content;
    return /*#__PURE__*/React__default['default'].createElement(AccordionItem.AccordionItem, {
      key: "accordion-item-".concat(slugify.slugify(title)),
      title: title,
      content: content
    });
  }));
};

Accordion.defaultProps = {
  accordionItems: [],
  classNames: ''
};
Accordion.propTypes = {
  accordionItems: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    content: PropTypes__default['default'].string.isRequired,
    title: PropTypes__default['default'].string.isRequired
  })).isRequired,
  className: PropTypes__default['default'].string,
  heading: PropTypes__default['default'].string
};
exports.Accordion = Accordion;
exports['default'] = Accordion;